export default "__VITE_ASSET__Up9HW$xy__"